import type React from "react";
import { Text } from "@mantine/core";
import { PLACEHOLDER } from "@utils/rowHelpers";

interface AltTextProps {
  value: string | null;
  /** Monospace — used for the id column. */
  mono?: boolean;
}

/** One cell of an expanded alternatives row: the candidate's value, or the
 * placeholder when it carries nothing for that column. Shared by the TM and
 * wd expanded rows so both lists read identically. */
const AltText: React.FC<AltTextProps> = ({ value, mono = false }) =>
  value === null ? (
    <Text size="xs" c="dimmed">
      {PLACEHOLDER}
    </Text>
  ) : (
    <Text
      size="sm"
      ff={mono ? "monospace" : undefined}
      ta="left"
      lineClamp={2}
    >
      {value}
    </Text>
  );

export default AltText;
